import type { HubConnection } from "@microsoft/signalr";
import adminApi from "../../../api/adminApi";

export const RUN_UPDATED_EVENT = "assistantRunUpdated";
export const TEXT_PREVIEW_EVENT = "assistantTextPreview";
export const CHAT_UPDATED_EVENT = "assistantChatUpdated";

export const joinAssistantHub = async (connection: HubConnection): Promise<void> => {
  const response = await adminApi.getAssistantSubscriptionToken();
  if (!response.success) {
    throw new Error(response.error?.message ?? "Could not get the Assistant subscription token");
  }

  await connection.invoke("Subscribe", response.data);
};
